import { Component, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { GeographyMasterService } from '../geography_master.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'state-master',
    templateUrl: './state_master.component.html'
})
export class stateMaster {

    collectionDetails = [];
    searchDataPafing = [];

    indexStart = 0;
    indexEnd = 10;
    pageSize = 5;
    pageNo = 1;
    totalPage = [1];

    searchInput = '';
    IsRecordUpdated = false;

    stateId = '';
    RegionId = '';
    stateNickName = '';
    name = '';
    pLanguageId = '';
    sLanguageId = '';
    ButtonValue = 'Save';
    viewMode = false;
    CreatedBy = '';
    IsDeleting = false;
    DeletedIndex = '';
    createdDate = '';
    country: any;
    regionId = '';

    regionArray = [];
    languageArray = [];

    primaryLanguage = [];
    secondaryLanguage = [];
    zone = [];


    constructor(private router: Router,
        public toastr: ToastsManager, vcr: ViewContainerRef,
        private PaymentService: GeographyMasterService,
        private fb: FormBuilder) {

        this.toastr.setRootViewContainerRef(vcr);
        this.PaymentService.GetRegionList('')
            .subscribe(departmentListData => {
                this.regionArray = departmentListData;
            });

        this.PaymentService.GetLanguageList()
            .subscribe(departmentListData => {
                this.languageArray = departmentListData;
            });


        this.PaymentService.GetStateList('')
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }


    pagingAgent(data) {
        this.pageNo = data;
        this.indexStart = (this.pageNo - 1) * this.pageSize + 1;
        this.indexEnd = (this.pageNo) * this.pageSize;
    }

    changeItemsPerPage(data) {
        if (this.collectionDetails.length > 0) {
            this.totalPage = [1]
            let j = 1;
            for (var i = 0; i < this.collectionDetails.length; i++) {
                i = i + this.pageSize;
                j = j + 1;
                this.totalPage.push(j);
            }
        }
        else {
            this.totalPage = [];
        }
        this.pageSize = data;
        this.indexStart = 0;
        this.indexEnd = this.pageSize;
    }

    searchInputFunction() {
        this.PaymentService.GetStateList(this.searchInput)
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                console.log("data", departmentListData);
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }

                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }

    UpdateRecordsPopulate(obj) {
        this.viewMode = false;
        this.stateNickName = obj["stateCode"];
        this.name = obj["name"];
        this.stateId = obj["id"];
        this.pLanguageId = obj["primaryLanguageId"];
        this.sLanguageId = obj["secondaryLanguageId"];
        this.createdDate = obj['createdDate'];
        this.ButtonValue = 'Update';
        this.country = obj['country'];
        this.regionId = obj['zoneId'];
        this.CreatedBy = obj['createdBy'];

        this.primaryLanguage = obj[""];
        this.secondaryLanguage = obj[""];
        this.zone = obj[""];
    }

    ViewRecordsPopulate(obj) {
        this.viewMode = true;

        this.pLanguageId = obj["primaryLanguageId"];
        this.sLanguageId = obj["secondaryLanguageId"];
        this.stateNickName = obj["code"];
        this.name = obj["name"];
        this.IsRecordUpdated = true;
        this.ButtonValue = 'Save';
        this.stateId = obj["id"];
        this.regionId = obj['id'];
    }

    reset() {
        this.viewMode = false;
        this.stateNickName = '';
        this.name = '';
        this.ButtonValue = 'Save';
        this.stateId = '';
        this.pLanguageId = '';
        this.sLanguageId = '';

        this.primaryLanguage = [];
        this.secondaryLanguage = [];
        this.zone = [];
        this.regionId = '';
    }

    memberFormSubmit() {
        if (this.stateId != '') {
            let data = {
                "createdBy": this.CreatedBy,
                "createdDate": this.createdDate,
                "id": this.stateId,
                'isDeleted':"false",
                'lastModifiedBy':'',
                'lastModifiedDate':"2017-07-06T11:18:13.8",
                "name": this.name,             
                "pinCodeId": [],
                'primaryLanguage': this.primaryLanguage,
                'primaryLanguageId': this.pLanguageId,
                'secondaryLanguage': this.secondaryLanguage,
                'secondaryLanguageId': this.sLanguageId,
                'stateCode': this.stateNickName,
                'zone': this.zone,
                'zoneId': this.regionId
            }
            this.PaymentService.EditState(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record updated succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("Something went wrong.");
                    }
                });
        }
        else {
            let data = {
                "stateCode": this.stateNickName,
                "name": this.name,
                'loggedInUserId': '',
                'primaryLanguageId': this.pLanguageId,
                'secondaryLanguageId': this.sLanguageId,
                'zoneId': this.regionId
            }
            this.PaymentService.CreateState(data)
                .subscribe(departmentListData => {
                    if (departmentListData == "Success") {
                        this.toastr.success("Record Added succesfuly.");
                        this.LoadGrid();
                    }
                    else {
                        this.toastr.error("Something went wrong.");
                    }
                });
        }
    }

    codegen() {
    }

    deleteProdutConfirm(id, i) {
        this.stateId = id;
        this.IsDeleting = true;
        this.DeletedIndex = i;
    }
    delete() {
        let data = {
            "id": this.stateId,
            "trackingState": this.DeletedIndex
        }
        // this.PaymentService.DeleteProductGroup(data)
        //     .subscribe(departmentListData => {

        //     });
    }
    deleteCancel() {
        this.IsDeleting = false;
        this.stateId = '';
        this.DeletedIndex = '';
    }

    LoadGrid() {
        this.PaymentService.GetStateList('')
            .subscribe(departmentListData => {
                this.collectionDetails = [];
                this.searchDataPafing = [];
                this.collectionDetails = departmentListData;
                if (this.collectionDetails.length > 5) {
                    let j = 1;
                    for (var i = 0; i < this.collectionDetails.length; i++) {
                        i = i + this.pageSize;
                        j = j + 1;
                        this.totalPage.push(j);
                    }
                }
                for (var i = 0; i < this.collectionDetails.length; i++) {
                    let arr = [];
                    arr = this.collectionDetails[i];
                    let rowNum = i;
                    this.searchDataPafing.push({ arr, "row": rowNum });
                }
                this.indexStart = 0;//((this.pageNo - 1) * this.pageSize) + 1;
                this.indexEnd = (this.pageNo * this.pageSize);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/geography_master/state_master/state_master.component.ts